import { render } from "./Index.vue?vue&type=template&id=75b218bf&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=75b218bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75b218bf"

export default script